import React from "react";
import ContactForm from "./ContactForm";
import "./HomePageComponents.css";
import headshot from "../images/headshot-silhouette-30.png";
import { Link } from "react-router-dom";
import { FaTruck } from "react-icons/fa6";
import { TbMoneybag } from "react-icons/tb";
import { LuMoveDiagonal } from "react-icons/lu";
import { VscGlobe } from "react-icons/vsc";
import {
  FaFacebook,
  FaTwitter,
  FaInstagram,
  FaArrowAltCircleUp,
} from "react-icons/fa";
import whyChooseUs from "../images/why_choose_us.png";
import { Box } from "@mui/material";
import { formatPossessive } from "../CommonFunctions";

export const FundraiserNavigation = () => {
  return (
    <div className="something-for-everyone-container">
      <div className="home-page-link-container">
        <Link to="/register-or-shop" className="fundraiser-button">
          Looking for an <b>ACTIVE</b> fundraiser?
          <span className="arrow-circle">
            <FaArrowAltCircleUp
              size={28}
              color="#0c5d53"
              style={{ transform: "rotate(45deg)" }}
            />
          </span>
        </Link>
        <Link to="/new-fundraiser-request" className="fundraiser-button">
          Looking to <b>START</b> a fundraiser?
          <span className="arrow-circle">
            <FaArrowAltCircleUp
              size={28}
              color="#0c5d53"
              style={{ transform: "rotate(45deg)" }}
            />
          </span>
        </Link>
      </div>
      <div className="something-for-everyone-div home-page-font">
        <Box className="floating-header">
          <div className="fund-raise-heading">
            A Fundraising Experience like NO Other!
          </div>
        </Box>
      </div>
    </div>
  );
};
export const FundraisingAtScale = () => {
  return (
    <div className="fundraiser-panel-div">
      <div className="fundraiser-text-div">
        <div className="fundraiser-text-header">
          The Make a Memory Advantage - Why Choose Us?
        </div>
        <div className="fundraiser-text-body">
          <ol>
            <li>
              Customize your Fundraiser - Every group is different, and so
              should your fundraiser. Our platform is customizable to what YOU
              need. Customize what you sell, when you sell it, and the options
              you want to offer your participants.
            </li>
            <li>
              We only offer high quality products - get products your customers
              will love and make money doing it.
            </li>
            <li>
              Access to your money when you need it! - We offer you access to
              funds throughout the fundraiser on our dashboard. We can direct
              deposit or send a check, so you get your money when you need it.
            </li>
            <li>
              Insights at the click of a button - Speaking of dashboards, our
              program offers fundraiser coordinators, team admins, and
              participants a slew of analytics, so they can keep up to date on
              their fundraiser.
            </li>
            <li>
              Smile! We are making memories - Our team will always greet you
              with a smile. After all, we are in the business to help kids
              create memories.
            </li>
          </ol>
        </div>
      </div>
      <img
        className="fundraiser-image"
        src={whyChooseUs}
        alt="Displays the headers of 'Why Choose MamFam` section in 5 separate bubbles around a central bubble labeled 'Fundraising Success!'"
      />
    </div>
  );
};

interface FeatureboxProps {
  icon: React.ReactNode;
  header: string;
  description: string;
}

const Featurebox: React.FC<FeatureboxProps> = ({
  icon,
  header,
  description,
}) => {
  return (
    <div className="feature-box">
      <div className="feature-box-icon">
        <div className="feature-box-icon-inner">{icon}</div>
        {/* Render the icon */}
      </div>
      <div className="feature-box-header">{header}</div>
      <div className="feature-box-description">{description}</div>
    </div>
  );
};

export const WhatWeDoForYou = () => {
  return (
    <div className="what-we-do-div">
      <div className="what-we-do-header">
        <p>
          <b>What We Do For YOU</b>
        </p>
      </div>
      <div className="feature-box-container">
        <Featurebox
          icon={<TbMoneybag color="black" />}
          header="40% - 80% profits, guaranteed."
          description="Combine the power of product fundraising with donation based fundraising, and have an INCREDIBLE fundraiser."
        />
        <Featurebox
          icon={<FaTruck color="black" />}
          header="Ship to Home or Ship to Organization"
          description="We offer the option for “expedited” shipping. Product is shipped directly to the customer within 3-5 business days. We also offer free shipping to the organization, where all products come separated by participant. No work = no hassle! Ask us about our new ship to participants!
"
        />
        <Featurebox
          icon={<LuMoveDiagonal color="black" />}
          header="No Minimums"
          description="Our philosophy - no group is too big or too small. If a participant wants to fundraise for something they truly believe in, then we will help them reach that goal.
"
        />
        <Featurebox
          icon={<VscGlobe color="black" />}
          header="Online & Brochure Sales"
          description="Appeal to everyone by pairing our e-commerce store with our brochure. It provides a perfect balance for optimal fundraising."
        />
      </div>
    </div>
  );
};

interface TestimonialProps {
  content: string;
  image: string;
  name: string;
  companyName: string;
}

const Testimonial: React.FC<TestimonialProps> = ({
  content,
  image,
  name,
  companyName,
}) => {
  return (
    <div className="testimonial-container">
      <div className="testimonial-content-container">
        {/* Wrap content with a div */}
        <div className="testimonial-content">{content}</div>
      </div>
      <div className="testimonial-avatar-container">
        <img
          className="avatar"
          src={image}
          alt={`${formatPossessive(name)} profile`}
        />
        <div className="testimonial-name">{name}</div>
        <div className="testimonial-company-name">{companyName}</div>
      </div>
    </div>
  );
};

export const TestimonialDisplay = () => {
  return (
    <div className="testimonial-div">
      <div className="testimonial-header">Testimonials</div>
      <div className="group-of-testimonials">
        <Testimonial
          content="The InstaRaise platform exceeded our expectations. We made $6,000 over our initial goal, which was mind-blowing. The fundraiser allowed us not only to fund our entire theatre season at a really high budget but to also offer financial assistance to our students and bring in guest artists and workshops."
          image={headshot}
          name="No Name"
          companyName="Some Company"
        />
        <Testimonial
          content="I run a Navy JROTC program. This year for the first time we used InstaRaise as a fundraising source. It worked out really well for us. We were actually surprised at how easy it was to set up and how easy it was to use and execute. Within 30 days we had raised over $65,000 for our students. We're very happy with the results, it worked out very well for us."
          image={headshot}
          name="No Name"
          companyName="Some Company"
        />
        <Testimonial
          content="We recently did a fundraiser with InstaRaise - what a great fundraiser that was. We raised over $12,000 in just 2 weeks! I've never done a fundraiser like that and it's super simple. Just setting up the website with the kids and then sending out text messages and sending their links and we were getting donations within the first 5 minutes."
          image={headshot}
          name="No Name"
          companyName="Some Company"
        />
      </div>
    </div>
  );
};

export const ContactUs = () => {
  return (
    <div className="contact-us-div">
      <ContactForm />
    </div>
  );
};

export const ContactUsPageComponent = () => {
  return (
    <div className="contact-us-div">
      <ContactForm />
    </div>
  );
};
